import { makeAutoObservable } from 'mobx';

class AuthStore {
  private authState: 'idle' | 'granted' | 'denied' = 'idle';

  constructor() {
    makeAutoObservable(this);
  }

  accessGranted() {
    this.authState = 'granted';
  }

  accessDenied() {
    this.authState = 'denied';
  }

  get hasAuth() {
    return this.authState === 'granted';
  }

  get isIdle() {
    return this.authState === 'idle';
  }
}

export const authStore = new AuthStore();
